const apiUrl = import.meta.env.VITE_API_URL

if (!apiUrl) {
	throw new Error('VITE_API_URL is required')
}

export const config = {
	apiUrl,
	debugMode: import.meta.env.VITE_DEBUG_MODE === 'true',
	appMode: import.meta.env.VITE_APP_MODE || import.meta.env.MODE,
}
